import React from "react";
import { LuArrowUpRight } from "react-icons/lu";
import { LuArrowDownLeft } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

const WalletTransactionCard = ({ item }) => {

    const navigate = useNavigate();
    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-US', options);
    }

    const getTransactionTitle = (item) => {
        if (item?.wallet_type === 'CASH') {
            return item?.type === 'CREDIT' ? 'Wallet Top-up' : 'Booking Payment';
        }
        if (item?.type === 'CREDIT') return 'Transfered Tokens';
        if (item?.reference_type === 'REVOKE') return 'Tokens Revoked';
        return 'Booking Payment';
    };


    return (

        <div className='vendor_token_transaction_box' onClick={() => item?.reference_type == 'KITCHEN_TICKET' ? navigate(`/order-pass/${item?.reference_id}`, { state: { fromPage: 'transaction' } }) : null}>
            <div className='d-flex'>
                <div className='d-flex justify-content-between align-items-center' >
                    <span className={` ${item?.type == 'CREDIT' ? 'token_credit' : 'token_debit'}`}> {item?.type == 'CREDIT' ? <LuArrowUpRight /> : <LuArrowDownLeft />} </span>
                </div>
                <div className='ms-2 mt-1'>
                    <p className='vendor_token_vendor_name'> {getTransactionTitle(item)} </p>
                    {item?.vendor_company_name &&
                        <p className='vendor_token_hub_name p-0 m-0'>
                            {item?.vendor_company_name}
                            {item?.hub_name && (<span className=' '>   {" "}({item?.hub_name}) </span>)}
                        </p>
                    }
                    {item?.reference_type == 'KITCHEN_TICKET' &&
                        <p className='vendor_token_hub_name p-0 m-0'>
                            Booking id : {item?.reference_id}
                        </p>
                    }
                    <p className='vendor_token_transaction_date'>
                        {formatDate(item?.created_at)}
                    </p>
                </div>
            </div>
            <div className='vendor_token_amount'>
                <span className={` ${item?.type == 'CREDIT' ? 'primary-text' : 'text-danger'}`} >
                    {item?.type == 'CREDIT' ? '+' : '-'}{item?.amount || 0} </span><br />
            </div>
        </div>


    )
}


export default WalletTransactionCard;